export enum RycIsProjectModule {
    None = 'none',
    Detail = 'detail',
    Viewer = 'viewer',
    Files = 'files',
    Budget = 'budget',
    InternalOffer = "offer-admin",
    Users = 'users'
}